__turbopack_context__.v({
  "legalText": "_7letYG_legalText",
});
